/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_xls_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 23H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V9"
    />
    <path
      fill="#000"
      d="m11.412 19-2.02-3.6 1.93-3.4h-1.65l-1.05 2.11L7.612 12h-1.71l1.92 3.5-2.01 3.5h1.72l1.07-2.14L9.632 19h1.78Zm2.696-1.2V12h-1.5v7h4.6v-1.2h-3.1Zm6.936 1.3c1.54 0 2.51-.83 2.51-2.15 0-1.04-.64-1.73-1.95-2.08l-.67-.18c-.6-.16-.83-.38-.83-.8 0-.45.39-.75.98-.75.51 0 .92.33 1.02.84l1.28-.6c-.18-.88-1.12-1.48-2.32-1.48-1.44 0-2.46.87-2.46 2.08 0 1.05.61 1.72 1.87 2.06l.67.18c.67.18.91.42.91.87 0 .48-.38.77-1.01.77-.64 0-.98-.29-1.32-1.15l-1.25.73c.37 1.11 1.23 1.66 2.57 1.66Z"
    />
  </svg>
)
export default file_xls_medium
